module.exports = __webpack_public_path__ + "media/images/alerta-0e6d7ae597d22a9b18b57455476aae90.png";